import {
  FETCH_SURCHARGE_CHECK_RESULT,
  CLEAR_SURCHARGE_CHECK_RESULT
} from './surchargeCheckerConstants';

const initialState = {
  surchargeResult: null
};

export default function surchargeCheckerReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case FETCH_SURCHARGE_CHECK_RESULT:
      return {
        ...state,
        surchargeResult: payload.surchargeResult
      };
    case CLEAR_SURCHARGE_CHECK_RESULT:
      return {
        ...state,
        surchargeResult: null
      };
    default:
      return state;
  }
}
